import { useCalendar } from './context';
import { CalendarChip } from './CalendarChip';
import { CarriedForwardChip } from './CarriedForwardChip';
import { splitCarriedForward, type PlacedEntry } from './model';

/**
 * Render ONE day's arranged entries, shared by the month/week {@link DayCell} and
 * the Päev agenda row so a day is identical in every lens (L14). On today's cell
 * the overdue, UNPRIORITISED documents collapse into the two finance-core
 * carried-forward summary groups (F1); a prioritised carried-forward document —
 * and every on-time entry — stays a normal {@link CalendarChip}. Any other day
 * renders its chips unchanged.
 */
export function DayEntries({ date, placed }: { date: string; placed: PlacedEntry[] }) {
  const { today, model } = useCalendar();
  const { incomeGroup, costGroup, chips } =
    date === today
      ? splitCarriedForward(placed, model.carriedForward)
      : { incomeGroup: null, costGroup: null, chips: placed };

  return (
    <>
      {incomeGroup && <CarriedForwardChip kind="income" group={incomeGroup} />}
      {costGroup && <CarriedForwardChip kind="cost" group={costGroup} />}
      {chips.map((p) => (
        <CalendarChip key={p.e.id} placed={p} />
      ))}
    </>
  );
}
